<template>
  <div>
    <Layout/>
    <h4>Atención: Tratamiento</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTratamiento" class="form-label">IdTratamiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTratamiento" name="idTratamiento" v-model="datoTratamiento.idTratamiento" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAtencion" name="idAtencion" v-model="datoTratamiento.idAtencion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="atencion" name="atencion" v-model="datoTratamiento.atencion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAtencionLOV"
                      title="Buscar Diagnósticos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoTratamiento.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoTratamiento.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarTratamiento" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTratamiento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTratamiento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdReceta</th>
          <th scope="col">IdTratamiento</th>
          <th scope="col">Observación</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">Estado</th>
          <th scope="col">TratamientoObservacion</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="receta in datosPaginados" :key="receta.idReceta">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(receta.idReceta)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(receta.idReceta)" title="Editar">edit_square</i></td>
          <td>{{receta.idReceta}}</td>
          <td>{{receta.idTratamiento}}</td>
          <td>{{receta.observacion}}</td>
          <td>{{getFormattedDate(receta.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(receta.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{receta.estado}}</td>
          <td>{{receta.tratamientoObservacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTratamiento(receta.idReceta)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idReceta" class="form-label">IdReceta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReceta" name="idReceta" v-model="datoReceta.idReceta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTratamiento" class="form-label">IdTratamiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTratamiento" name="idTratamiento" v-model="datoReceta.idTratamiento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoReceta.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoReceta.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoReceta.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarReceta" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReceta" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Atencion -->
    <AtencionLOV @DatosAtencion="GetDataAtencionLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Receta -->
    <RecetaLOVdet @DatosReceta="GetDataRecetaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import AtencionLOV from '../../components/lovs/AtencionLOV.vue'
// Listas de valores master
// Listas de valores details
import RecetaLOVdet from '../../components/lovs/RecetaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, AtencionLOV
// Listas de valores master
// Listas de valores details
, RecetaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      tratamientos : [],
      datoTratamiento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTratamiento: '',
// Variables master
// Variables details
      recetas : [],
      datoReceta : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTratamiento = this.$route.params.p_idtratamiento
    this.abrirEditar(this.p_idTratamiento)
    this.getRecetas()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoTratamiento.idTratamiento === ''){
        swal("Error!", "El elemento idTratamiento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTratamiento.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTratamiento.tipo === ''){
        swal("Error!", "El elemento tipo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTratamiento.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTratamiento.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarTratamiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tratamientos', this.datoTratamiento)
          swal("Correcto!", "Tratamiento creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTratamiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tratamientos', this.datoTratamiento)
          swal("Correcto!", "Tratamiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTratamiento={}
      this.titulo   = 'Crear Atención: Tratamiento'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTratamiento){
      this.modalWindow = true
      if(idTratamiento != null){    
           api.get('/vwtratamientos/'+idTratamiento).then(resp=>{
          this.datoTratamiento = resp.data;
           });
      }
      this.titulo   = 'Editar Atención: Tratamiento'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTratamiento(){
      this.$router.push('/Tratamiento')
    },
// Procedimientos master
// Procedimientos detalle
    async getRecetas() {
      const resp = await api.get('/recetas')
      this.recetas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.recetas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwrecetas/nombre/'+this.nombreBusqueda).then(response=>{
          this.recetas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.recetas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwrecetas').then(response=>{
      this.recetas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.recetas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoReceta.idTratamiento === ''){
        swal("Error!", "El elemento idTratamiento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoReceta.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoReceta.tipo === ''){
        swal("Error!", "El elemento tipo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoReceta.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoReceta.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarReceta(){
      if(this.validarForm() === 1){
        try {
          this.datoReceta.idTratamiento = this.datoTratamiento.idTratamiento;
          await api.post('/recetas', this.datoReceta)
          this.getRecetas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Receta creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReceta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/recetas', this.datoReceta)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Receta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoReceta={}
      this.titulo   = 'Crear Atención: Tratamiento'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idReceta){
      this.modalWindow = true
      if(idReceta != null){    
           api.get('/vwrecetas/'+idReceta).then(resp=>{
          this.datoReceta = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atención: Tratamiento'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idReceta){
      this.modalWindow = true
      if(idReceta != null){
        this.$router.push('/recetamd/'+idReceta)
      }
    },
    async deleteReceta (idReceta) {
      try{
        await api.delete('/recetas/'+idReceta)
          this.getRecetas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataAtencionLOV(data) {
      this.datoTratamiento.idAtencion = data.idAtencion;
      this.datoTratamiento.atencion = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataRecetaLOVdet(data) {
      this.datoReceta.idReceta = data.idReceta;
      this.datoReceta.receta = data.nombre;
    },
// Listas de valores details
  },
}
</script>
